import { useEffect } from 'react';
import CloseButton from '@/shared/components/configurator/CloseButton';
import ConstructorButton from '@/shared/components/configurator/ConstructorButton';
import {
    useConfiguratorOpenedCameraPositionValue,
    useSetCameraPosition,
} from '@/shared/components/configurator/atoms/camera-position';
import { useConfiguratorZoomedSetState } from '@/shared/components/configurator/atoms/configurator-zoomed';
import {
    useCurrentModelStateValue,
    useSetCurrentModelState,
} from '@/shared/components/configurator/atoms/current-model-state';
import { CONFIGURATOR_WALL_COLOR_DEFAULT } from '@/shared/config/const';
import { useCurrentModelPropertiesValue } from '../atoms/current-model-properties';
import ColorInput from './ColorInput';

const ConfiguratorWallColorPicker = () => {
    const setCameraPosition = useSetCameraPosition();
    const configuratorOpenedCameraPosition = useConfiguratorOpenedCameraPositionValue();
    const setConfiguratorZoomed = useConfiguratorZoomedSetState();
    const currentModelState = useCurrentModelStateValue();
    const setCurrentModelState = useSetCurrentModelState();
    const currentModelProperties = useCurrentModelPropertiesValue();
    const wallsProps = currentModelProperties.find((prop) => prop.type === 'color');

    const pickedColors = currentModelState.color.value.map((color) => (color ? color.toLowerCase() : color));
    const title =
        typeof currentModelState.openedWallColorPickerIndex === 'number' && wallsProps
            ? wallsProps.property[currentModelState.openedWallColorPickerIndex].label
            : null;

    useEffect(() => {
        setCameraPosition(
            typeof currentModelState.openedWallColorPickerIndex === 'number'
                ? wallsProps?.property[currentModelState.openedWallColorPickerIndex].cameraPosition ||
                      configuratorOpenedCameraPosition
                : configuratorOpenedCameraPosition,
        );
        setConfiguratorZoomed(true);
    }, [setCameraPosition, currentModelState.openedWallColorPickerIndex, setConfiguratorZoomed]);

    return (
        <div className="configurator">
            <div className="configurator-top">
                {wallsProps?.property && title && <div className="configurator-title text-l">{title}</div>}
                <CloseButton
                    onClick={() => {
                        setCurrentModelState((prev) => ({
                            ...prev,
                            openedWallColorPickerIndex: null,
                        }));
                        setCameraPosition(configuratorOpenedCameraPosition);
                        setConfiguratorZoomed(false);
                    }}
                />
            </div>
            <ColorInput />
            <div className="configurator-hero-buttons configurator-color-picker-buttons">
                {typeof currentModelState.openedWallColorPickerIndex === 'number' &&
                    (!!pickedColors[currentModelState.openedWallColorPickerIndex]
                        ? pickedColors[currentModelState.openedWallColorPickerIndex] !== CONFIGURATOR_WALL_COLOR_DEFAULT
                        : false) && (
                        <ConstructorButton
                            variant="outline"
                            onClick={() => {
                                setCurrentModelState((prev) => {
                                    const colors = [...prev.color.value];
                                    colors[currentModelState.openedWallColorPickerIndex!] = null;

                                    return {
                                        ...prev,
                                        color: {
                                            title: CONFIGURATOR_WALL_COLOR_DEFAULT,
                                            value: colors,
                                        },
                                    };
                                });
                            }}
                        >
                            Сбросить
                        </ConstructorButton>
                    )}
                <ConstructorButton
                    variant="blue"
                    onClick={() => {
                        setCurrentModelState((prev) => ({
                            ...prev,
                            openedWallColorPickerIndex: null,
                        }));
                        setCameraPosition(configuratorOpenedCameraPosition);
                        setConfiguratorZoomed(false);
                    }}
                >
                    Сохранить и закрыть
                </ConstructorButton>
            </div>
        </div>
    );
};

export default ConfiguratorWallColorPicker;
